var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "s-pagination"
  }, [_c('li', {
    staticClass: "s-arrow",
    attrs: {
      "disabled": _vm.current <= 1
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.withPage(_vm.current - 1)
    }
  }, [_vm._v("<")])], 1), _c('li', {
    staticClass: "s-text-gray-darker my-auto mr-1"
  }, [_vm._v(" " + _vm._s(_vm.current) + " ")]), _c('li', {
    staticClass: "s-text-gray-light my-auto"
  }, [_vm._v("/")]), _c('li', {
    staticClass: "s-text-gray-darker my-auto ml-1"
  }, [_vm._v(" " + _vm._s(_vm.last) + " ")]), _c('li', {
    staticClass: "s-arrow",
    attrs: {
      "disabled": _vm.current >= _vm.last
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.withPage(_vm.current + 1)
    }
  }, [_vm._v(">")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }